import React, { useContext, useEffect } from 'react'
import { StoresContext } from '@App/contexts'
import { FetchType } from '@Components/WorkItemV2/fetch-type-enum'
import { observer } from 'mobx-react'
import ViewWork from '@Components/ViewWork'
import WorkDraftHeader from '@Components/ViewWork/Headers/WorkDraftHeader'
import PointPreloader from '@Components/Preloaders/PointPreloader'
import { useParams } from 'react-router'
import { analyticsSendPage } from '@App/common/utils/analytics-utils'
import { PARAM } from '@App/navigation/param'

const ViewDraftScene = () => {
    const { workStore } = useContext(StoresContext)
    const params = useParams<typeof PARAM>()

    useEffect(() => {
        analyticsSendPage('view_draft')
        const workId = params.workId

        if (!workId) {
            return
        }

        workStore.getWorkById(Number(workId), FetchType.MLC).then()
        return () => {
            workStore.destroyViewWork()
        }
    }, [])

    return (
        <>
            <title>View Work Draft</title>

            <div className="view-draft-work-scene-2">
                {workStore.workById ? (
                    <>
                        <WorkDraftHeader
                            work={workStore.workById}
                            editOnClick={() => workStore.workById && workStore.setWorkDraftToLocal(workStore.workById)}
                        />
                        <ViewWork viewWork={workStore.workById} workType="draft" />
                    </>
                ) : (
                    <PointPreloader />
                )}
            </div>
        </>
    )
}

export default observer(ViewDraftScene)
